/**
 * Сервис для хранения данных динамического поля select в приложении
 * @package DynamicFieldClass
 * @version 1.0
 * @author BOLOTOV I.P.
 * @since 17.08.2022
 * @copyright (c) Internet-Frigate {@link http://www.ifrigate.ru}
 */
import {DynamicFieldService} from '../../../core/classes/DynamicFieldService.service';
import {InterfaceAppServiceRegister} from '@app/app.interface';
import {Injectable} from '@angular/core';
import {IFieldSelect} from '../interfaces/FieldSelect.interface';
import {BehaviorSubject} from 'rxjs';
@Injectable()
/** Сервис для хранения данных динамического поля select */
export abstract class SelectServiceLib extends DynamicFieldService {
    /** Значение динамического поля */
    fieldValue: {[key: string]: InterfaceAppServiceRegister } = {};
    /** Отфильтрованные данные */
    options: InterfaceAppServiceRegister[] = [];
    /** Конфигурации динамического поля */
    declare field: IFieldSelect;
    /** Флаг отображения spinner */
    isShowSpinner: BehaviorSubject<boolean> = new BehaviorSubject(false);
}
